import React from 'react'
import {
    Form,
  Input,
  Radio,
  Space,Picker,Toast,List,
  Button,Selector,TextArea,ImageUploader,DatePicker,NavBar,Image,Grid,Popup
} from 'antd-mobile-v5';
import dayjs from 'dayjs'

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../PostsAdd/index.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';
import { environment } from '../../service/baseUrl';
import {
    GetPlanets,SaveNNFile,GetDataDictionarysByCode,GetPostById,SavePostInfo,GetSystemMemorys,SensitiveWordsVerify
  } from '../../service/service';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            fileList: [],

            visible6: false,
            Range: [],
            Planet: [],

            IsPlanet: true,
            isSubmit: true,

            PlanetId: 0,
            RangeId: 0,

            PlanetName: "请选择",
            RangeName: "请选择",
            postInfo: {}
        };
    }

    componentDidMount() {
        var that = this;

        GetDataDictionarysByCode("TZKJFW").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    Range: [arry]
                })
            }
        })

        GetPlanets().then(res => {
            if (res.success) {
                var list = res.result;
                list.map(item => {
                    if (item.headImg != null && item.headImg != "") {
                        //item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                        if (item.headImg != null) {
                            if (item.headImg.indexOf("https://") > -1) {
                                var urls = item.headImg.split("https://").filter(Boolean);
                                item.headImg = urls.length > 0 ? `https://${urls[urls.length - 1]}` : "";
                            } else {
                                item.headImg = environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                            }
                        }
                    } else {
                        item.headImg = item.headImg == null ?
                            "https://api.weibinyi.com/images/niannian/thtx.jpg" :
                            environment.apiEndpoint + "/NNFiles/Img/" + item.headImg;
                    }
                })
                var IsPlanet = true;
                if (list.length == 0) {
                    IsPlanet = false;
                } else {
                    that.setState({
                        PlanetId: list[0].id,
                        PlanetName: list[0].name,
                    })
                }
                that.setState({
                    Planet: list,
                    IsPlanet
                })
            }
        })


        const { location } = this.props;
        const { id } = location.state || {}; // 获取 URL 参数
        if (id) {
            GetPostById(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    that.formRef.current.setFieldsValue({
                        Remark: res.result.remark,
                    })

                    setTimeout(() => {
                        var item1 = that.state.Range[0].filter(x => x.value == result.rangeId);
                        that.initPlanet(result.planetId);
                        that.setState({
                            RangeId: result.rangeId,
                            RangeName: item1[0] == null ? "请选择" : item1[0].label,
                        })

                    }, 1000);

                    var list = []
                    result.imgs.map((item, index) => {
                        list.push({
                            key: 999 - index,
                            url: environment.apiEndpoint + item,
                            thumbnailUrl: environment.apiEndpoint + item,
                        })
                    })

                    that.setState({
                        id: id,
                        imgName: result.headImg,
                        fileList: list,
                        postInfo: result,
                    })
                }
            })
        } else {
            that.initRange();
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

    }

    initRange(){
        var that = this;
        if (that.state.Range.length == 0 || that.state.Range[0].length == 0) {
            setTimeout(() => {
                that.initRange();
            }, 500);
            return;
        }
        var item = that.state.Range[0].filter(x => x.label == "所有人");
        that.setState({
            RangeId: item[0] == null ? null : item[0].value,
            RangeName: item[0] == null ? "请选择" : item[0].label,
        })
    }

    initPlanet(planetId) {
        var that = this;
        if (that.state.Planet == null || that.state.Planet.length == 0) {
            setTimeout(() => {
                that.initPlanet(planetId)
            }, 500);
            return;
        }
        var item2 = that.state.Planet.filter(x => x.id == planetId);
        that.setState({
            PlanetId: planetId,
            PlanetName: item2[0] == null ? "请选择" : item2[0].name
        })
    }

    submitForm = () => {
        var that = this;
        if (!that.state.isSubmit) {
            Toast.show({ icon: 'fail', content: '帖子发布中，请勿重复提交！' });
            return;
        }
        this.formRef.current.validateFields()
            .then(values => {
                if (this.state.RangeId == 0) {
                    Toast.show({ content: '请选择可见范围！' });
                    return;
                }
                // if (this.state.PlanetId == 0) {
                //     Toast.show({ content: '请选择星球！' });
                //     return;
                // }

                var imgs = [];
                this.state.fileList.map(item => {
                    imgs.push(item.url.split('/').pop());
                });
                that.state.postInfo.imgs = [];
                const submitData = {
                    ...that.state.postInfo,
                    ...values,
                    RangeId: this.state.RangeId,
                    Imgs: imgs,
                    PlanetId: this.state.PlanetId == 0 ? null : this.state.PlanetId,
                };

                that.setState({
                    isSubmit: false,
                })

                var Contents = [];
                Contents.push(submitData.Remark);
                var model = {
                    Contents: Contents
                };
                SensitiveWordsVerify(model).then(res=>{
                    if (res.result) {
                        SavePostInfo(submitData).then(res => {
                            that.setState({
                                isSubmit: true,
                            })
                            if (res.success) {
                                Toast.show({ icon: 'success', content: '提交成功！' });
                                setTimeout(() => {
                                    that.props.navigate('/posts', { replace: true });
                                }, 2000);
                            }
                        })
                    } else {
                        Toast.show({
                            icon: 'fail',
                            content: '表单数据中包含违规内容，请修改后重试！',
                        });
                        that.setState({
                            isSubmit: true,
                        })
                    }
                })
            })
            .catch(error => {
                if (error.errorFields) {
                    Toast.show({ icon: 'fail', content: '请检查表单' });
                } else {
                    Toast.show({ icon: 'fail', content: error.message || '提交失败' });
                }
            });
        
    }


    render() {


        return (
            <div className="postAdd">
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/posts', { replace: true }); // 传递状态
                }}>
                    念念星辰
                </NavBar>

                <Form
                    name='form'
                    ref={this.formRef}
                    layout='horizontal'
                    footer={
                        <div>
                            <div style={{
                                backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                , fontWeight: "600", color: "#fff"
                            }} onClick={() => {
                                this.submitForm();
                            }}>
                                发 布
                            </div>
                        </div>
                    }
                >


                    <Form.Item name='Remark' label=''
                        rules={[{ required: true, message: '请输入相关内容' }]}>
                        <TextArea
                            placeholder='Ta很愿意听到你的想法'
                            maxLength={200}
                            rows={6}
                            showCount
                        />
                    </Form.Item>


                    <div style={{
                        paddingTop: "10px", marginLeft: "10px", marginRight: "10px", paddingBottom: "10px",
                        borderTop: "solid 1px #ececec", borderBottom: "solid 1px #ececec"
                    }}>
                        <Grid columns={3} gap={8}>
                            <Grid.Item span={3}>

                                <ImageUploader
                                    columns={3}
                                    maxCount={3}
                                    style={{ '--cell-size': '40px' }}
                                    value={this.state.fileList || []}
                                    defaultValue={this.state.fileList || []}
                                    beforeUpload={async (file) => {
                                        console.log('BeforeUpload - 文件信息:', file);
                                        if (this.state.PlanetId == 0) {
                                            Toast.show({ icon: 'fail', content: '选择星球后，才能上传图片！' });
                                            return false;
                                        }
                                        if (!(file instanceof File)) {
                                            Toast.show({ icon: 'fail', content: '无效的文件！' });
                                            return false;
                                        }
                                        if (file.size > 5 * 1024 * 1024) {
                                            Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                            return false;
                                        }

                                        // if (this.state.PlanetId != 0) {
                                        //     var res = await GetSystemMemorys(this.state.PlanetId);
                                        //     if (res.success) {
                                        //         var count = 0;
                                        //         res.result.map(item => {
                                        //             count += item.fileSize;
                                        //         })
                                        //         if (count > 500) {
                                        //             Toast.show({ content: '该星球文件空间已满！' });
                                        //             return false;
                                        //         }
                                        //     }
                                        // }

                                        const fileCopy = new File([file], file.name, { type: file.type });
                                        return fileCopy;
                                    }}
                                    onChange={(fileList) => {
                                        console.log('OnChange - 文件列表:', fileList);
                                        this.setState({ fileList });
                                    }}
                                    upload={async (file) => {
                                        try {
                                            console.log('Upload - 开始上传:', file);

                                            // 1. 验证文件对象
                                            if (!(file instanceof File)) {
                                                throw new Error('无效的文件对象');
                                            }

                                            // 2. 创建临时预览URL
                                            const tempUrl = URL.createObjectURL(file);
                                            console.log('临时预览URL创建成功:', tempUrl);

                                            // 3. 上传文件
                                            const formData = new FormData();
                                            formData.append('file', file);
                                            formData.append('userid', this.state.userInfo.id);
                                            formData.append('scoureName', "Img");
                                            formData.append('planetId', this.state.PlanetId == 0 ? null : this.state.PlanetId);

                                            const response = await SaveNNFile(formData);
                                            console.log('上传响应:', response);

                                            // 4. 确保返回正确的URL格式
                                            let imageUrl;
                                            if (typeof response === 'string') {
                                                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                            } else if (response.result) {
                                                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                            } else {
                                                throw new Error('无效的服务器响应');
                                            }

                                            this.setState({
                                                imgName: response.result
                                            })
                                            // 5. 释放临时URL
                                            URL.revokeObjectURL(tempUrl);

                                            return {
                                                url: imageUrl
                                            };
                                        } catch (error) {
                                            console.error('上传过程出错:', error);
                                            Toast.show({ icon: 'fail', content: '上传失败' });
                                            throw error;
                                        }
                                    }}
                                    children={
                                        <Image src={"https://api.weibinyi.com/images/niannian/4/13-08.png"} fit='fill'
                                            width={110} height={110} />
                                    }
                                />
                            </Grid.Item>
                        </Grid>

                    </div>


                    {
                        this.state.IsPlanet ?
                            <List header=''>
                                <List.Item extra={this.state.PlanetName} onClick={async () => {
                                    this.setState({
                                        visible6: true,
                                    })
                                }}>
                                    选择星球
                                </List.Item>
                            </List> :
                            <div style={{
                                paddingTop: "10px", marginLeft: "10px", marginRight: "10px", paddingBottom: "10px",
                                borderBottom: "solid 1px #ececec", textAlign: 'center', lineHeight: "35px", fontSize: "17px"
                            }}>
                                请先关注先人空间
                    </div>
                    }
                    
                    <Popup
                        visible={this.state.visible6}
                        mask={true}
                        onMaskClick={() => {
                            this.setState({
                                visible6: false
                            })
                        }}
                        bodyStyle={{
                            borderTopLeftRadius: '25px',
                            borderTopRightRadius: '25px',
                            minHeight: '40vh',
                        }}
                    >
                        <Grid columns={4} gap={8}>

                            <Grid.Item span={4}>
                                <div style={{ textAlign: "center", marginTop: "12px", marginBottom: "10px" }}>
                                    <div style={{ fontWeight: "600", fontSize: "14px" }}>
                                        星球选择
                                </div>
                                </div>
                            </Grid.Item>

                            {
                                this.state.Planet.map(item => {
                                    return (<>
                                        <Grid.Item span={1}>
                                            <div style={{ marginRight: "10%", float: "right" }} onClick={() => {
                                                var model = this.state.Planet.filter(x => x.id == item.id);
                                                if (model.length > 0) {
                                                    this.setState({
                                                        PlanetId: model[0].id,
                                                        PlanetName: model[0].name,
                                                        visible6: false
                                                    })
                                                }
                                            }}>
                                                <Image
                                                    src={item.headImg}
                                                    style={{ borderRadius: 20 }}
                                                    fit='cover'
                                                    width={50}
                                                    height={50}
                                                />
                                            </div>
                                        </Grid.Item>
                                        <Grid.Item span={3}>
                                            <div style={{ fontSize: "16px", lineHeight: "48px" }} onClick={() => {
                                                var model = this.state.Planet.filter(x => x.id == item.id);
                                                if (model.length > 0) {
                                                    this.setState({
                                                        PlanetId: model[0].id,
                                                        PlanetName: model[0].name,
                                                        visible6: false
                                                    })
                                                }
                                            }}>
                                                {item.name}
                                            </div>
                                        </Grid.Item>
                                        <Grid.Item span={4}>
                                            <div style={{ borderBottom: "solid 2px #e5e5e5", width: "90%", marginLeft: "5%" }}></div>
                                        </Grid.Item>
                                    </>)
                                })
                            }

                        </Grid>
                    </Popup>

                    <List header=''>
                        <List.Item extra={this.state.RangeName} onClick={async () => {
                            const value = await Picker.prompt({
                                columns: this.state.Range
                            })
                            
                            if (this.state.Range == null || this.state.Range.length == 0
                                || value == null || value.length == 0) {
                                return;
                            }
                            var item = this.state.Range[0].filter(x => x.value == value[0]);
                            if (item.length > 0) {
                                this.setState({
                                    RangeId: item[0].value,
                                    RangeName: item[0].label,
                                })
                            }
                        }}>
                            可见范围
                                </List.Item>
                    </List>


                </Form>


                {/* <div style={{ textAlign: "center", fontSize: "15px", fontWeight: "600" }}>
                    温馨提示：管理员审核后，会进行分类
                </div> */}


                <BottomMenu  position="fixed" selectKey="posts" />

            </div>
        )
    }
}

export default withNavigate(Index);